<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/59VbVo/tc-custom/9780253026033.jpg?1737782421065" alt="This image is the cover for the book After Emerson, American Philosophy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">After Emerson, American Philosophy
      </h1>
      <p class="bookDescription body article font2">
        <b>The author of <i>Emerson &amp; Self-Culture</i> shares essays covering such themes as identity, experience, ethics, poetry, philosophy, history, and race.</b><br/><br/>John T. Lysaker works between and weaves together questions and replies in philosophical psychology, Emerson studies, and ethics in this book of deep existential questioning. Each essay in this atypical, philosophical book employs recurring terms, phrases, and questions that characterize our contemporary age. Setting out from the idea of where we are in an almost literal sense, Lysaker takes readers on an intellectual journey into thematic concerns and commitments of broad interest, such as the nature of self and self-experience, ethical life, poetry and philosophy, and history and race. In the manner of Emerson, Cavell, and Rorty, Lysaker’s vibrant writing is certain to have a transformative effect on American philosophy today.<br/><br/><b>“An original and stimulating book, manifesting a level of reflection and existential concern of the highest order. It is intellectually and personally honest.” —Robert E. Innis, author of <i>Susanne Langer in Focus</i></b><br/><br/><b>“There is something fresh and hence refreshing in the manner in which John T. Lysaker takes up familiar topics. He shows, with both arresting details and an evolving design, how the conduct of life (to use Emerson’s expression) demands a form of thought frequently at odds with contemporary fashions and preoccupations, with institutionally entrenched approaches and all too rigidly policed discourses.” —Vincent Colapietro, author of <i>Experience, Interpretation, and Community</i></b><br/><br/><b>“Acknowledged as one of his generations premier Emerson scholars, Lysaker goes beyond his earlier work, <i>Emerson &amp; Self-Culture . . . </i>[T]he writing is stimulating, vibrant, challenging, risky, and fecund. Recommended.” —D. B. Boersma, <i>Choice</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John T. Lysaker
      </h2>
      
      <p class="authorDescription body article"><P>John T. Lysaker is Professor of Philosophy at Emory University. He is author of Emerson and Self-Culture (IUP).</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?54f02ac8